module.exports = __webpack_public_path__ + "img/cpwg_formation_1.d6462d25.svg";